import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StockageService, environment } from '@perval/shared';
import { fetchAuthSession } from 'aws-amplify/auth';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DrupalService {
  mainUrl = `${environment.host}`;

  constructor(
    private http: HttpClient,
    private readonly stockageService: StockageService,
  ) {}

  public async createSession(): Promise<void> {
    const { idToken } = (await fetchAuthSession()).tokens ?? {};
    const response = await firstValueFrom(
      this.http.post(`${this.mainUrl}/api/createsession`, {
        IdToken: idToken?.toString(),
        provider: this.stockageService.getItem('Provider'),
      }),
    );
    this.stockageService.setItem('X-Perval-Context', response as string);
  }

  // Permet de vérifier si on a bien un contexte Drupal.
  public isSessionDrupalExists(): boolean {
    return this.stockageService.getItem('X-Perval-Context') !== null;
  }
}
